import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import { CSVLink } from "react-csv"
import { IUsageSearchResultRowType } from "../../../types/usageTypes/IUsageGroupsSearchResult";
import { USAGE_SEARCH_RESULTS_VIEW, USAGERESULTTABLE_VIEW } from "../../../Consts";
import DropDownButtonDefaultView from "./DropDownButtonDefaultView";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IComponentView } from "../../../../redux/types/ComponentView";
import ITooltip from "../../../components/Tooltip/IToolTip";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { IComponentViewItemReduxStore, IComponentViewReduxStore } from "../../../../redux/types/ComponentViewReduxStore";
import React from "react";
import { ArrowDownload20Regular, Search20Regular, Settings20Regular } from "@fluentui/react-icons";
import { FluentIcon } from "@fluentui/react-icons";

export interface IUsageSearchToolBar {
    componentViews?: IComponentViewReduxStore;
    data?: IUsageSearchResultRowType[];
    getIconForExpandAll?: () => FluentIcon;
    onClickExpandAll?: (rows: IUsageSearchResultRowType[]) => void;
    onClickSave?: () => void;
    showFieldsModal?: (componentFieldName: string) => void;
    hasChanges?: string[]
    settingsModalViewData?: IRepertoireComponentDataItem;
    setActiveComponentView?: (activeComponentView: any) => void;
    activeComponentView?: IComponentView;
    userIsConfigureComponentViewAdmin?: boolean;
    componentViewPreference?: IComponentViewsPreference;
    bulkMatchSearchLabel?: string;
    bulkMatchSearchDisabled?: boolean;
    onBulkMatchSearch?: () => void;
    canUpdateUsages: boolean;
    bulkMatchSearchDisabledReason?: string;
    bulkAdjustmentDisabled?: boolean;
    bulkAdjustmentDisabledReason?: string;
    onBulkAdjustmentSearch?: () => void;
}

const UsageSearchToolbar = (props: IUsageSearchToolBar) => {
    const { 
        canUpdateUsages,
        data,
        getIconForExpandAll,
        onClickExpandAll,
        onClickSave,
        showFieldsModal,
        hasChanges,
        componentViews,
        settingsModalViewData,
        setActiveComponentView,
        activeComponentView,
        userIsConfigureComponentViewAdmin,
        componentViewPreference,
        bulkMatchSearchLabel,
        bulkMatchSearchDisabled,
        onBulkMatchSearch,
        bulkMatchSearchDisabledReason,
        bulkAdjustmentDisabled,
        bulkAdjustmentDisabledReason,
        onBulkAdjustmentSearch
    } = props;
    const [buttonComponentViews, setButtonComponentViews] = React.useState<IComponentView[] | undefined>(componentViews?.usageSearchResultsViews?.componentViews || []);

    const currentChanges = hasChanges ?? [];

    const saveDisabled = !canUpdateUsages || currentChanges.length === 0;

    React.useEffect(() => {
        if (componentViews?.usageSearchResultsViews?.componentViews) {
            setButtonComponentViews(componentViews.usageSearchResultsViews.componentViews);
        }
    }, [componentViews]);

    return (
        <div
            className="toolbarWrapper flexRow flexJustifyContentSpaceBetween"
            id={"toolbar"}
        >
            <div className="flexRow flexAlignItemsBaseLine">
                <CSVLink
                    filename={"UsageSearchResults.csv"}
                    data={data.map(({ matchesExpanded, ...keepAttrs }) => ({
                        ...keepAttrs,
                        title: keepAttrs.title?.replace(/"/g, '""')
                    }))}

                    className="btn"
                    enclosingCharacter={'"'}
                    delimiter={","}
                >
                    <IconTextButton
                        text="Export"
                        icon={ArrowDownload20Regular}
                    />
                </CSVLink>

                <div style={{paddingLeft:"6px", paddingRight:"6px"}}>
                    <IconTextButton text="Show All Matches" icon={getIconForExpandAll()}
                        onClick={() => onClickExpandAll(data)} />
                </div>

                {bulkMatchSearchLabel && (
                    <div style={{ paddingLeft: "6px", paddingRight: "6px" }}>
                        <IconTextButton
                            text={bulkMatchSearchLabel}
                            icon={Search20Regular}
                            disabled={
                                !canUpdateUsages ||
                                bulkMatchSearchDisabled
                            }
                            tooltip={bulkMatchSearchDisabledReason}
                            onClick={() => onBulkMatchSearch?.()}
                        />
                    </div>
                )}

                <div style={{ paddingLeft: "6px", paddingRight: "6px" }}>
                    <IconTextButton
                        text="Search IPs to Adjust"
                        icon={Search20Regular}
                        disabled={bulkAdjustmentDisabled}
                        tooltip={bulkAdjustmentDisabledReason}
                        onClick={() => onBulkAdjustmentSearch?.()}
                    />
                </div>

            </div>
            <div className="flexRow flexAlignItemsBaseLine">
                         <div style={{ paddingLeft: "6px", paddingTop: "10px"  }}>
                <DropDownButtonDefaultView
                isUserAdmin={userIsConfigureComponentViewAdmin}
                componentViewPreference={componentViewPreference}
                setActiveComponentView={setActiveComponentView}
                activeComponentView={activeComponentView}
                componentViews={buttonComponentViews}
                settingsModalViewData={settingsModalViewData}
                showFieldsModal={showFieldsModal}
                dropDownName={USAGE_SEARCH_RESULTS_VIEW}
                />
            </div>
           <div className="flexRow flexAlignItemsBaseLine">
             <div style={{ paddingLeft: "6px" }}>
               {userIsConfigureComponentViewAdmin ? <IconTextButton text="&nbsp;Configure Data Fields" icon={Settings20Regular}
                    onClick={() => showFieldsModal ?
                        showFieldsModal(USAGERESULTTABLE_VIEW) : null} />
             : <ITooltip
                        tooltipContent={'User does not have access'}
                        showTooltip={true}
                    >
            <div style={{ paddingLeft: "6px" }}>
                <IconTextButton 
                text="&nbsp;Configure Data Fields" 
                icon={Settings20Regular}
                disabled={true}/>
            </div>
             </ITooltip>}
          </div> 

    


            <div className="saveButton" >
                    <div className="saveButtonContainer btn-group" >
                        <button
                            type="button"
                            title="Save current Usage Group changes"
                            aria-disabled={saveDisabled}
                            className={saveDisabled ? "disabledSaveButton" : "saveButton"}
                            onClick={() => onClickSave?.()}
                            disabled={saveDisabled}
                            data-testid="save-usage-changes"
                        >
                            <div className="saveButtonText">
                                Save Changes
                            </div>
                        </button>               
                    </div>
                   
            </div>
            </div>
        </div>
        </div>
    );
}
export default UsageSearchToolbar